import { ApiError, apiFetch } from '@/lib/apiFetch';
import type { MeResponse } from '@sklad-sync/shared';
import { useCallback, useEffect, useState } from 'react';

type AuthState =
  | { status: 'loading' }
  | { status: 'authed'; user: MeResponse }
  | { status: 'anon' };

export function useAuth(): AuthState & {
  refresh: () => Promise<void>;
  logout: () => Promise<void>;
} {
  const [state, setState] = useState<AuthState>({ status: 'loading' });

  const refresh = useCallback(async () => {
    try {
      const user = await apiFetch<MeResponse>('/api/auth/me');
      setState({ status: 'authed', user });
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) {
        setState({ status: 'anon' });
      } else {
        setState({ status: 'anon' });
      }
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await apiFetch('/api/auth/logout', { method: 'POST' });
    } finally {
      setState({ status: 'anon' });
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...state, refresh, logout };
}
